module.exports = __webpack_public_path__ + "img/grafics.af19d18c.png";